// Wingman v2 has no field for the workflow a turn refers to, so the id rides
// in the user text. The note stays out of the rendered bubble.
const LEGACY_NOTE = ". Use it when this request refers to the selected workflow; otherwise respond to the request normally.\n\n";
const escapeRegExp = (text: string) => text.replace(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
const NOTE = ". Use it when this request refers to the selected workflow; otherwise respond to the request normally. Read its current saved version before reporting its status or making changes, and update this workflow instead of creating a replacement unless the user asks for a separate workflow.\n\n";
const SELECTION = new RegExp(`^Selected workflow: [A-Za-z0-9][A-Za-z0-9_-]*(?:${escapeRegExp(NOTE)}|${escapeRegExp(LEGACY_NOTE)})`);

export function withWorkflowSelection(text: string, workflowId: string): string {
  return `Selected workflow: ${workflowId}${NOTE}${text}`;
}

export function withoutWorkflowSelection(text: string): string {
  return text.replace(SELECTION, "");
}
